import { useMutation } from 'react-query';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { CustomType } from 'src/services/napi/customTypes/interfaces/fetchCustomTypes.interface';
import { createCustomType } from 'src/services/napi/customTypes/createCustomType';
import { UseAddContentModelMutationParams } from './interfaces/useAddContentModelMutation.interface';
import { useNotification } from '../../../../providers/notificationsProvider';

const addContentModel = async (data: CustomType) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  const response = await createCustomType(currentProject._id, data);
  return response;
};

export const useAddContentModelMutation = ({
  onError,
  onSuccess
}: UseAddContentModelMutationParams) => {
  const { notify } = useNotification();

  return useMutation((data: CustomType) => addContentModel(data), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Content Model Created Successfully' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
